export const LABEL_OPTIONS = [
  { key: "receiving", fallback: "Receiving" },
  { key: "wip", fallback: "WIP" },
  { key: "shipping", fallback: "Shipments" },
  { key: "products", fallback: "Products" },
  { key: "inventory", fallback: "Inventory" },
  { key: "traceability", fallback: "Traceability" },
  { key: "qa_reports", fallback: "QA Reports" },
  { key: "lab_samples", fallback: "Lab Samples" },
  { key: "customers", fallback: "Customers" },
  { key: "suppliers", fallback: "Suppliers" },
  { key: "warehouses", fallback: "Warehouses" },
];

export const DEFAULT_THEME = {
  primaryColor: "#0B1F3A",
  sidebarColor: "#12406B",
  headerColor: "#FFFFFF",
};

export function buildFormValuesFromTenant(tenant) {
  const settings = tenant?.settings ?? {};
  const theme = settings.theme ?? {};
  const profile = settings.profile ?? {};

  return {
    name: tenant?.name ?? "",
    slug: tenant?.slug ?? "",
    company_email: profile.email ?? "",
    phone_number: profile.phone ?? "",
    address1: profile.address1 ?? profile.address ?? "",
    address2: profile.address2 ?? "",
    city: profile.city ?? "",
    postal_code: profile.postal_code ?? "",
    state: profile.state ?? "",
    country: profile.country ?? "",
    logo_url: tenant?.logo_url ?? "",
    primary_color:
      tenant?.primary_color ?? theme.primaryColor ?? DEFAULT_THEME.primaryColor,
    sidebarColor: theme.sidebarColor ?? DEFAULT_THEME.sidebarColor,
    headerColor: theme.headerColor ?? DEFAULT_THEME.headerColor,
    modules: { ...(settings.modules ?? {}) },
    labels: { ...(settings.labels ?? {}) },
  };
}

export function buildTenantPayload(formValues) {
  return {
    name: formValues.name,
    slug: formValues.slug,
    logo_url: formValues.logo_url || null,
    primary_color: formValues.primary_color,
    settings: {
      profile: {
        email: formValues.company_email || null,
        phone: formValues.phone_number || null,
        address1: formValues.address1 || null,
        address2: formValues.address2 || null,
        city: formValues.city || null,
        postal_code: formValues.postal_code || null,
        state: formValues.state || null,
        country: formValues.country || null,
      },
      theme: {
        primaryColor: formValues.primary_color,
        sidebarColor: formValues.sidebarColor,
        headerColor: formValues.headerColor,
      },
      modules: formValues.modules,
      labels: formValues.labels,
    },
  };
}
